import _get from "lodash/get";
import styled from 'styled-components';
import { rem } from 'polished';
import authTheme from '../styles/authTheme';
var FooterActions = styled.div.withConfig({
  displayName: "FooterActions",
  componentId: "sc-5c6k67-0"
})(["border-top:1px solid ", ";margin-top:", ";padding:", " 0;text-align:center;"], function (_ref) {
  var theme = _ref.theme;
  return _get(theme, 'auth.divider.color', authTheme.auth.divider.color);
}, rem(16), rem(16));
export default FooterActions;